import { useContext } from "react";

import {
  ItemsContext,
  useSelectedItem,
} from "../../../../context/itemsContext";
import { useAvailableElevatedStock } from "@coworker/app/src/hooks/useAvailableElevatedStock";
import { useItemInfo } from "../../../../../shared/hooks/item/useItemInfo";

import PiecesInput from "../../Inputs/PiecesInput";
import { MediumSkeletonListItem } from "@coworker/app/src/components/RoomSettings/Molecules/skeletons/MediumSkeletonListItem";

import type { ChangeEvent, KeyboardEvent } from "react";
import type { MultiOrderItem } from "../../../../types/items";
import { ItemListViewItemCard } from "@coworker/apprestructured/src/multi-order-addons/components/ItemsSelection/ItemsListView/ItemListViewItemCard/ItemListViewItemCard";
// Commenting this for a rework once multi order is demoed on the 15th of May 2025 --- COAPP-11152
/* import { useTasksForProduct } from "@coworker/app/src/hooks/useTasksForProduct";
import { isOpenAddon } from "@coworker/app/src/components/InputPopup/Location";
import { sumOver } from "@coworker/app/src/helpers/mapHelpers"; */
import React from "react";
import styles from "./items-list-view-item.module.css";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

interface ItemsListItemProps {
  item: MultiOrderItem;
  index: number;
}

const ItemsListViewItem = ({ item, index }: ItemsListItemProps) => {
  const dispatch = useContext(ItemsContext).dispatch;
  const selectedItem = useSelectedItem(index);
  const stockInfo = useAvailableElevatedStock(`ART${item.articleNumber}`);
  const { data: basicItemInfo, isLoading } = useItemInfo(item.articleNumber);
  // Commenting this for a rework once multi order is demoed on the 15th of May 2025 --- COAPP-11152
  /* const relatedTasks = useTasksForProduct(article.articleNumber ?? ""); */

  /* const relatedAddons = useMemo(() => {
    const relatedAddons: any = {};
    if (!relatedTasks?.list?.forEach) return relatedAddons;
    relatedTasks?.list?.forEach((task) => {
      if (isOpenAddon(task)) {
        const key = task.location_grid_code;
        const current = relatedAddons[key] || [];
        current.push(task);
        relatedAddons[key] = current;
      }
    });
    return relatedAddons;
  }, [relatedTasks]); */

  /* const relatedTasksOrderCount = useMemo(() => {
    return sumOver(
      relatedAddons[article.refillLocation],
      (task: any) => task?.requested_quantity
    );
  }, [relatedAddons, article.refillLocation]); */

  const handleSelect = () => {
    dispatch({
      type: "SELECT_ITEM",
      payload: {
        index,
        availableStock: stockInfo?.available,
        item: { ...item, name: basicItemInfo?.name || "" },
      },
    });
  };

  const handlePieces = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: "CHANGE_PIECES",
      payload: { index, pieces: e.target.value },
    });
  };

  const handleInputClick = () => {
    dispatch({
      type: "CLEAR_INPUT",
      payload: { index, pieces: "" },
    });
  };
  const isItemSelected = item.articleNumber === selectedItem?.articleNumber;
  const homeLocationGridCode = item.home_location || item.pickupLocation;
  const combinedClasses = `${styles["items-list-item"]} ${
    isItemSelected ? styles["selected"] : ""
  }`;

  const handleCardKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleSelect();
    }
  };

  return (
    <div key={index}>
      {isLoading && <MediumSkeletonListItem />}
      {!isLoading && basicItemInfo && (
        <div
          className={combinedClasses}
          onClick={handleSelect}
          onKeyDown={handleCardKeyDown}
          role="checkbox"
          aria-checked={isItemSelected}
          tabIndex={0}
        >
          <ItemListViewItemCard
            homeLocationGridCode={homeLocationGridCode}
            item={basicItemInfo}
            lastRefilledQuantity={item.lastRefilledQuantity}
            lastRefilled={item.lastRefilled}
            refillLocationGridCode={item.refillLocation}
          />
          <div
            className={styles["items-list-item-checkbox"] || ""}
            onClick={(event) => event.stopPropagation()}
          >
            <FixaCheckbox
              id={`select-item-${index}`}
              value={index.toString()}
              checked={item.articleNumber === selectedItem?.articleNumber}
              onChange={handleSelect}
            />
          </div>
        </div>
      )}
      {!!selectedItem && (
        <PiecesInput
          onChange={handlePieces}
          onClick={handleInputClick}
          message={selectedItem.validation.message}
          hasError={
            (selectedItem.validation.hasWarning ?? false) ||
            (selectedItem.validation.hasError ?? false)
          }
          value={selectedItem.selectedPieces ?? ""}
          maxPieces={item.maxAmount}
          limitMessage="maximumCapacityString"
        />
      )}
    </div>
  );
};

export default ItemsListViewItem;
